import { SVGProps } from "react"

const PublicTransportIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.266 14.6673H4.73269C3.59935 14.6673 2.66602 13.7406 2.66602 12.6006V3.40065C2.66602 2.26732 3.59269 1.33398 4.73269 1.33398H11.266C12.3993 1.33398 13.3327 2.26066 13.3327 3.40065V12.6006C13.3327 13.7406 12.406 14.6673 11.266 14.6673Z"
      stroke="#0E2846"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.3327 8.66732H3.66602C3.11268 8.66732 2.66602 8.22065 2.66602 7.66732V6.33398C2.66602 5.78065 3.11268 5.33398 3.66602 5.33398H12.3327C12.886 5.33398 13.3327 5.78065 13.3327 6.33398V7.66732C13.3327 8.22065 12.886 8.66732 12.3327 8.66732Z"
      stroke="#0E2846"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.66366 11.8001H5.66964"
      stroke="#0E2846"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3297 11.8001H10.3357"
      stroke="#0E2846"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.33398 3.33398H9.66732"
      stroke="#0E2846"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)

export default PublicTransportIcon
